/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompanyUsersQuery } from '../../models/get-company-users-query';
import { GetCompanyUsersQueryResult } from '../../models/get-company-users-query-result';

export interface GetCompanyUsersPost$Params {
  
    /**
     * companyId
     */
    body?: GetCompanyUsersQuery
}

export function getCompanyUsersPost(http: HttpClient, rootUrl: string, params?: GetCompanyUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyUsersQueryResult>> {
  const rb = new RequestBuilder(rootUrl, getCompanyUsersPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompanyUsersQueryResult>;
    })
  );
}

getCompanyUsersPost.PATH = '/GetCompanyUsers';
